export default "__VITE_ASSET__DvAOf$zw__"